import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import ESCOcuppations from '../../../../../../assets/ESCOcuppations.json';
import {OfertasService} from 'src/app/services/ofertas.service';
import {Router} from "@angular/router";
import {environment} from "../../../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {CustomTreeControl} from "../../../../../helpers/CustomTree";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";

interface ESCONode {
  name: string;
  code: string;
  URI: string;
  subgroup?: ESCONode[];
}

const TREE_DATA: ESCONode[] = ESCOcuppations;

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  code: string;
  level: number;
}

const educationMap = new Map<string,string>();
educationMap.set('0', "No es posible obtener un nivel educacional de la oferta"); 
educationMap.set('1', "La oferta requiere un nivel mínimo de básica o menos");
educationMap.set('2', "La oferta requiere un nivel mínimo de media");
educationMap.set('3', "La oferta requiere un nivel mínimo profesional");
educationMap.set('4', "La oferta requiere un nivel mínimo técnico superior");


const economicSectorMap = new Map<string,string>();
economicSectorMap.set('0','No es posible obtener el rubro de la empresa a partir del aviso');
economicSectorMap.set('1','A - Agricultura, silvicultura y pesca');
economicSectorMap.set('2','B - Explotación de minas y canteras');
economicSectorMap.set('3','C - Industrias manufactureras');
economicSectorMap.set('4','D - Suministro de electricidad, gas, vapor y aire acondicionado');
economicSectorMap.set('5','E - Suministro de agua; alcantarillado, gestión de desechos y actividades de saneamiento');
economicSectorMap.set('6','F - Construcción');
economicSectorMap.set('7','G - Comercio al por mayor y al por menor; reparación de los vehículos de motor y de las motocicletas');
economicSectorMap.set('8','H - Transporte y almacenamiento');
economicSectorMap.set('9','I - Alojamiento y servicios de comida');
economicSectorMap.set('10','J - Información y comunicación');
economicSectorMap.set('11','K - Actividades financieras y de seguros.');
economicSectorMap.set('12','L - Actividades inmobiliarias');
economicSectorMap.set('13','M - Actividades profesionales, científicas y técnicas');
economicSectorMap.set('14','N - Actividades administrativas y servicios de apoyo');
economicSectorMap.set('15','O - Administración pública y defensa; planes de seguridad social de afiliación obligatoria');
economicSectorMap.set('16','P - Enseñanza');
economicSectorMap.set('17','Q - Servicios sociales y relacionados con la salud humana.');
economicSectorMap.set('18','R - Artes, entretenimiento y recreación');
economicSectorMap.set('19','S - Otras actividades de servicio');
economicSectorMap.set('20','T - Actividades de los hogares en calidad de empleadores, actividades indiferenciadas de producción de bienes y servicios de los hogares para uso propio.');
economicSectorMap.set('21','U - Actividades de organizaciones y órganos extraterritoriales');

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.css'],
})




export class TreeComponent implements OnInit {


  sugerencias: Array<string>;
  total: any;


  form = new FormGroup({
    occupation: new FormControl({value: '', disabled: true}),
    education: new FormControl({value: '', disabled: true}),
  
    job_offer: new FormControl({value: '', disabled: true}),
    confidence: new FormControl(''),
    aboutciuo: new FormControl(''),
    occupation_suggestion: new FormControl(null),
    comment: new FormControl(''),
    is_there_vacancies: new FormControl(null), 
    vacancies_number: new FormControl(null),
  });


  constructor(public ofertasService: OfertasService,
              private router: Router,
              private http: HttpClient,
              public snackBar: MatSnackBar,
  ) {
    this.dataSource.data = TREE_DATA;

  }


  @Input() oferta;
  voto = <any>{};
  ocupacionElegida: string;
  nivelEducacionalElegido: string;
  sectorEconomicolegido: string;
  ciuo08CL4D: any;
  confidenceLevel: boolean;
  confidenceLevelotherocc: boolean;
  vacantes_multiples: boolean;
  vacantes_cantidad: number;


  @Output() reload: EventEmitter<boolean> = new EventEmitter();


  treeControl = new CustomTreeControl<ExampleFlatNode>(
    node => node.level, node => node.expandable);

  private _transformer = (node: ESCONode, level: number) => {
    return {
      expandable: !!node.subgroup && node.subgroup.length > 0,
      name: node.name,
      code: node.code,
      level: level,
    };
  }
  // tslint:disable-next-line: member-ordering
  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.subgroup);


  // tslint:disable-next-line: member-ordering
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  searchTerm: any;


  ngOnInit() {

  }

  public searchSuggest(event) {
    console.log(event.target.value);
    //const term = event.target.value;
    const term = event.target.value;
    // this.getSearchSuggest(event.target.value).then(result=> {
    //   console.log(result);
    //
    // })
    this.getOccupation(term).then(result => {
      console.log(result);
      this.sugerencias = result;
      this.total = result.length
    })
  }

  selectGroup(code) {
    console.log(code)
//  this.treeControl.expand(this.treeControl.dataNodes[]);
    this.expandNode(code);
    this.description(code);
    this.ocupacionElegida = code;

  }

  getOccupation(term): Promise<any> {
    return this.http.get(environment.apiUrl + '/searchoccupation?occupation=' + term).toPromise();

  }


  getGroup4D(code): Promise<any> {
    return this.http.get(environment.apiUrl + '/ciuo08cl4d/' + code).toPromise();

  }

  expandNode(code) {
    this.treeControl.collapseAll();

    this.treeControl.dataNodes.forEach((node) => {
      if (node.code === code) {

        this.treeControl.expandParents(node)
      }
    });
  }


  description(code) {
    console.log(code)
    this.getGroup4D(code).then(r => {
      console.log(r);
      this.ciuo08CL4D = r;
    })


  }

  lastQuestion($event) {
    if ($event.value >= 1 && $event.value <= 13){
      this.confidenceLevel = true
    }
  else {
    this.confidenceLevel = false
    this.form.controls['aboutciuo'].reset()
  }
  }


  vacanciesQuestion($event) {
    if ($event.value ==2){
      this.vacantes_multiples = true
    }
  else {
    this.vacantes_multiples = false
    this.form.controls['vacancies_number'].reset()
  }
  }
   

  onSubmit() {
    console.log(this.form.value.aboutciuo)

    if ( ((this.form.valid && this.ocupacionElegida  && this.ocupacionElegida && 
      !(!this.form.value.confidence && this.form.value.confidence !== 0) )
    || 
  (this.form.valid && this.form.value.confidence === '0' && !(!this.form.value.aboutciuo && this.form.value.aboutciuo  !== 0)))
// Si las vacantes están puestas
//Verificar que sea 0 o 1, y si es 2 que el number sea mayor que 1 (999 es no valido, que es mayor de 1)
      && ((this.form.value.is_there_vacancies=='0' || this.form.value.is_there_vacancies=='1') || (this.form.value.is_there_vacancies =='2' && this.form.value.vacancies_number >1))
      ) {

      this.form.value.job_offer = this.oferta.id;
      this.form.value.occupation = this.ocupacionElegida;
      this.form.value.education = this.nivelEducacionalElegido;
      
      console.log('Esto es lo que se mandará al backedn');
      console.log(this.form.value);
      this.snackBar.open('Enviando respuesta...', null, {
              duration: 3000
            });
      this.ofertasService.votar(this.form.value)
        .subscribe(
          () => {
            this.snackBar.open('Voto exitoso. Obteniendo otro aviso.', null, {
              duration: 3000
            });
            //this.router.onSameUrlNavigation = 'reload';
            //this.router.navigate(["tagging"]);
            this.treeControl.collapseAll();
            this.ocupacionElegida = null;
            this.form.reset()
            this.nivelEducacionalElegido = null;
            
            this.reload.emit(true);
            this.searchTerm = null;
            this.sugerencias = null;
          },
          () => {
            console.log('No se pudo completar el voto');
          });
    } else {
      return this.snackBar.open('El formulario no es válido. Revise que estén los datos', null, {
        duration: 3000
      });
    }


  }

  checkOcupation() {
    if (this.ocupacionElegida) {
      return this.ocupacionElegida
    } else {
      return 'No hay categoría seleccionada'
    }

  }


  checkEducation() {
    if (this.nivelEducacionalElegido != null) {
      return educationMap.get(this.nivelEducacionalElegido)
    } else {
      return 'No hay categoría seleccionada'
    }

  }

  checkEconomicSector() {
    if (this.sectorEconomicolegido != null) {
      return economicSectorMap.get(this.sectorEconomicolegido)
    } else {
      return 'No hay categoría seleccionada'
    }

  }
}
